import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    CCID: "",
    AssessmenType: "",
    AssessmentDate: "",
    NFQuestions:"",
    MaxCredits:"",
}

const SWResultSlice = createSlice({
    name: "SWResultSlice",
    initialState,

    reducers: {
        SWResultsData(state, action) {
            return {
                // ...state,
                CCID: action.payload.CCID,
                AssessmenType: action.payload.AssessmenType,
                AssessmentDate: action.payload.AssessmentDate,
                NFQuestions: action.payload.NFQuestions,
                MaxCredits: action.payload.MaxCredits,
            };
        }
    }
})
export const { SWResultsData } = SWResultSlice.actions;
export default SWResultSlice.reducer;